import { combineReducers } from 'redux';
import scheduleGetReducer from './scheduleGetReducer';
import reservationConfirmReducer from './reservationConfirmReducer';
import scheduleReservationStateReducer from './scheduleReservationStateReducer';

const index = combineReducers({
  scheduleGet: scheduleGetReducer,
  getReservationConfirmReducer: reservationConfirmReducer,
  scheduleReservationState: scheduleReservationStateReducer,
});

export default index;
